import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { GlobalStateProvider } from "./context/GlobalStateContext";
import Home from "./Pages/Home";

const ROUTE_CONFIG = {
  "/stg": { 
    client: "stg",
    title: "Saudi Tadawul Exchange",
  },
  "*": { 
    client: "us",
    title: "S&P 100",
  },
};

function ProviderFromRoute({ children }) {
  const { pathname } = useLocation();

  const routeConfig =
    ROUTE_CONFIG[pathname] ??
    ROUTE_CONFIG["*"];

  return (
    <GlobalStateProvider
      key={routeConfig.client}
      client={routeConfig.client}
      title={routeConfig.title}
    >
      {children}
    </GlobalStateProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ProviderFromRoute>
        <Routes>
          {Object.entries(ROUTE_CONFIG).map(([path, config]) => (
            <Route
              key={path}
              path={path}
              element={<Home />}
            />
          ))}
        </Routes>
      </ProviderFromRoute>
    </BrowserRouter>
  );
}
export default App;